module.exports = __webpack_public_path__ + "img/logo-big.34053c55.png";